import { useRouter, useRoute } from "vue-router";
import { AnyStateMachine } from "xstate-5";
import { createSharedMachine, inspector } from "vue-app/utils/xstate";

export const useSharedMachine = <TMachine extends AnyStateMachine>(
  sharedMachine: ReturnType<typeof createSharedMachine<TMachine>>,
  machine: TMachine,
  extraInput?: Record<string, unknown>
) => {
  const router = useRouter();
  const route = useRoute();

  return sharedMachine(machine, {
    input: { router, route, ...extraInput },
    inspect: inspector().inspect,
  });
};
